class MegaMenuHover extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.details.querySelector('.mega-menu__content');
    this.header = null;
    this.closeTimeout = null;
    this.openTimeout = null;
  }

  connectedCallback() {
    this.header = document.querySelector('.header-wrapper');

    this.summary.addEventListener('click', (e) => {
      if (window.innerWidth >= 1024) {
        // If the click landed on the title anchor, let the browser navigate.
        if (e.target.closest('a[href]')) {
          return;
        }
        e.preventDefault();
        if (this.details.open) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      }
    });

    this.addEventListener('mouseenter', () => {
      if (window.innerWidth < 1024) return;
      clearTimeout(this.closeTimeout);
      this.openTimeout = setTimeout(() => this.openMenu(), 50);
    });

    this.addEventListener('mouseleave', () => {
      if (window.innerWidth < 1024) return;
      clearTimeout(this.openTimeout);
      this.closeTimeout = setTimeout(() => this.closeMenu(), 150);
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.details.open) {
        this.closeMenu();
        this.summary.focus();
        return;
      }

      if (!this.details.open) return;

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        const focusableLinks = [...this.content.querySelectorAll('a[href], button:not([disabled])')];
        if (focusableLinks.length === 0) return;

        const currentIndex = focusableLinks.indexOf(document.activeElement);

        let nextIndex;
        if (e.key === 'ArrowDown') {
          nextIndex = currentIndex < focusableLinks.length - 1 ? currentIndex + 1 : 0;
        } else if (e.key === 'ArrowUp') {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : focusableLinks.length - 1;
        } else if (e.key === 'Home') {
          nextIndex = 0;
        } else if (e.key === 'End') {
          nextIndex = focusableLinks.length - 1;
        }

        focusableLinks[nextIndex].focus();
      }
    });

    this.details.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.closeMenu();
      });
    });
  }

  openMenu() {
    document.querySelectorAll('mega-menu-hover').forEach((el) => {
      if (el !== this) {
        clearTimeout(el.closeTimeout);
        clearTimeout(el.openTimeout);
        el.closeMenu();
      }
    });

    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.showBackdrop();

    if (this.header) {
      this.header.preventHide = true;
      this.header.classList.add('header-wrapper--mega-open');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  closeMenu() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
    this.hideBackdrop();
    if (this.header) {
      this.header.preventHide = false;
      const anyOpen = document.querySelector('mega-menu-hover details[open]');
      if (!anyOpen) {
        this.header.classList.remove('header-wrapper--mega-open');
      }
    }
  }

  close() {
    this.closeMenu();
  }

  showBackdrop() {
    let backdrop = document.querySelector('.mega-menu-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'mega-menu-backdrop';
      document.body.appendChild(backdrop);
    }
    // Force reflow before adding visible class for transition
    backdrop.offsetHeight;
    backdrop.classList.add('mega-menu-backdrop--visible');
    backdrop.onclick = () => this.closeMenu();
  }

  hideBackdrop() {
    const backdrop = document.querySelector('.mega-menu-backdrop');
    if (backdrop) {
      backdrop.classList.remove('mega-menu-backdrop--visible');
      backdrop.onclick = null;
    }
  }
}

if (!customElements.get('mega-menu-hover')) {
  customElements.define('mega-menu-hover', MegaMenuHover);
}
